<template>
  <div>
    <hr />
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Número</th>
          <th scope="col">Nombre Paciente</th>
          <th scope="col">Cédula</th>
          <th scope="col">Tipo</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="cargaamb in datosPaginados" :key="cargaamb.idCargaAmb">
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirModalEditar(cargaamb.idCargaAmb)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>{{ cargaamb.numero }}</td>
          <td>{{ cargaamb.nombrePaciente }}</td>
          <td>{{ cargaamb.cedula }}</td>
          <td>{{ cargaamb.tipo }}</td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPaginaTodos(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- Información Básica -->
              <h5 class="mb-3">Información Básica</h5>
              <div class="row mb-3">
                <div class="col-md-2">
                  <label for="idCargaAmb" class="form-label"
                    >ID Carga Ambulatoria</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="idCargaAmb"
                    name="idCargaAmb"
                    v-model="datoCargaAmb.idCargaAmb"
                    disabled
                  />
                </div>
                <div class="col-md-2">
                  <label for="numero" class="form-label">Número</label>
                  <input
                    type="text"
                    class="form-control"
                    id="numero"
                    name="numero"
                    v-model="datoCargaAmb.numero"
                    style="text-transform: uppercase"
                    required
                  />
                </div>
                <div class="col-md-2">
                  <label for="cedula" class="form-label">Cédula</label>
                  <input
                    type="text"
                    class="form-control"
                    id="cedula"
                    name="cedula"
                    v-model="datoCargaAmb.cedula"
                    style="text-transform: uppercase"
                    required
                  />
                </div>
                <div class="col-md-6">
                  <label for="nombrePaciente" class="form-label"
                    >Nombre del Paciente</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="nombrePaciente"
                    name="nombrePaciente"
                    v-model="datoCargaAmb.nombrePaciente"
                    style="text-transform: uppercase"
                    required
                  />
                </div>
              </div>
              <!-- Diagnósticos -->
              <h5 class="mb-3">Diagnósticos</h5>
              <div class="row">
                <template v-for="i in 5" :key="'diag' + i">
                  <div class="col-md-2 mb-1">
                    <label :for="'diag0' + i" class="form-label"
                      >Diagnóstico {{ i }}</label
                    >
                  </div>
                  <div class="col-md-4 mb-1">
                    <input
                      type="text"
                      class="form-control"
                      :id="'diag0' + i"
                      :name="'diag0' + i"
                      v-model="datoCargaAmb['diag0' + i]"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </template>
              </div>
              <!-- Laboratorios -->
              <h5 class="mb-3">Laboratorios</h5>
              <div class="row">
                <template v-for="i in 10" :key="'laboratorio' + i">
                  <div class="col-md-2 mb-1">
                    <label
                      :for="'laboratorio' + (i < 10 ? '0' + i : i)"
                      class="form-label"
                      >Laboratorio {{ i }}</label
                    >
                  </div>
                  <div class="col-md-4 mb-1">
                    <input
                      type="text"
                      class="form-control"
                      :id="'laboratorio' + (i < 10 ? '0' + i : i)"
                      :name="'laboratorio' + (i < 10 ? '0' + i : i)"
                      v-model="
                        datoCargaAmb[
                          i < 10 ? 'laboratorio0' + i : 'laboratorio' + i
                        ]
                      "
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </template>
              </div>
              <!-- Imágenes -->
              <h5 class="mb-3">Imágenes</h5>
              <div class="row">
                <template v-for="i in 10" :key="'imagen' + i">
                  <div class="col-md-2 mb-1">
                    <label
                      :for="'imagen0' + (i < 10 ? '0' + i : i)"
                      class="form-label"
                      >Imagen {{ i }}</label
                    >
                  </div>
                  <div class="col-md-4 mb-1">
                    <input
                      type="text"
                      class="form-control"
                      :id="'imagen0' + (i < 10 ? '0' + i : i)"
                      :name="'imagen0' + (i < 10 ? '0' + i : i)"
                      v-model="
                        datoCargaAmb[i < 10 ? 'imagen0' + i : 'imagen' + i]
                      "
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </template>
              </div>
              <!-- Detalles adicionales -->
              <h5 class="mb-3">Detalles Adicionales</h5>
              <div class="row mb-3">
                <div class="col-md-6">
                  <label for="fecha" class="form-label">Fecha</label>
                  <input
                    type="date"
                    class="form-control"
                    id="fecha"
                    name="fecha"
                    v-model="datoCargaAmb.fecha"
                    required
                  />
                </div>
                <div class="col-md-3">
                  <label for="horaDesde" class="form-label">Hora Desde</label>
                  <input
                    type="time"
                    class="form-control"
                    id="horaDesde"
                    name="horaDesde"
                    v-model="datoCargaAmb.horaDesde"
                    required
                  />
                </div>
                <div class="col-md-3">
                  <label for="horaHasta" class="form-label">Hora Hasta</label>
                  <input
                    type="time"
                    class="form-control"
                    id="horaHasta"
                    name="horaHasta"
                    v-model="datoCargaAmb.horaHasta"
                    required
                  />
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-12">
                  <label for="motivo" class="form-label">Motivo</label>
                  <textarea
                    class="form-control"
                    id="motivo"
                    name="motivo"
                    v-model="datoCargaAmb.motivo"
                    style="text-transform: uppercase"
                  ></textarea>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";
import { validarForm } from "../../modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";
//import { format } from 'date-fns';

import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
export default {
  props: {
    p_idTramite: {
      type: Number,
      required: true,
    },
    p_idCarga: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      cargaambs: [],
      datoCargaAmb: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      tramites: [],
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
    };
  },

  mounted() {
    this.getDataPaginaTodos(this.paginaActual);
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas() {
      return Math.ceil(this.cargaambs.length / this.elementosPorPagina);
    },
    getDataPaginaTodos(noPagina) {
      alert("CONTROL 1: " + this.p_idTramite);
      alert("CONTROL 2: " + this.p_idCarga);
      api.get("/vwcargaambs/tramite-carga/" +
            this.p_idTramite +
            "/" +
            this.p_idCarga
        )
        .then((response) => {
          this.cargaambs = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini =
            noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.cargaambs.slice(ini, fin);
        });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarForm() {
      const requiredFields = [
        "idTramite",
        "numero",
        "nombrePaciente",
        "codVal",
        "cedula",
        "diag1",
        "diag2",
        "diag3",
        "diag4",
        "diag5",
        "motivo",
        "tipo",
        "fecha",
        "horaDesde",
        "horaHasta",
        "laboratorio01",
        "laboratorio02",
        "laboratorio03",
        "laboratorio04",
        "laboratorio05",
        "laboratorio06",
        "laboratorio07",
        "laboratorio08",
        "laboratorio09",
        "laboratorio10",
        "imagen01",
        "imagen02",
        "imagen03",
        "imagen04",
        "imagen05",
        "imagen06",
        "imagen07",
        "imagen08",
        "imagen09",
        "imagen10",
      ];
      const requiredFieldsText = [
        "idTramite",
        "numero",
        "nombrePaciente",
        "codVal",
        "cedula",
        "diag1",
        "diag2",
        "diag3",
        "diag4",
        "diag5",
        "motivo",
        "tipo",
        "fecha",
        "horaDesde",
        "horaHasta",
        "laboratorio01",
        "laboratorio02",
        "laboratorio03",
        "laboratorio04",
        "laboratorio05",
        "laboratorio06",
        "laboratorio07",
        "laboratorio08",
        "laboratorio09",
        "laboratorio10",
        "imagen01",
        "imagen02",
        "imagen03",
        "imagen04",
        "imagen05",
        "imagen06",
        "imagen07",
        "imagen08",
        "imagen09",
        "imagen10",
      ];
      return validarForm(this.datoCargaAmb, requiredFields, requiredFieldsText);
    },
    abrirModalEditar(idCargaAmb) {
      this.modalWindow = true;
      if (idCargaAmb != null) {
        api.get("/vwcargaambs/" + idCargaAmb)
          .then((resp) => {
            this.datoCargaAmb = resp.data;
            this.datoCargaAmb.fecha = dateFormat.getFormattedDateISO(
              this.datoCargaAmb.fecha
            );
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Editar ";
      this.btnCrear = false;
      this.btnEditar = true;
    },
  },
};
</script>
